import React from "react"


const MoveToOnePlanBanner = (props) => {
    return (
        <div className='move-to-one-plan-banner module'>
            <div className='row'>
                <div className='col-8 col-lg-8'>
                    <h1 className='m-0 mb-2'>One and done: make the switch to The One Plan through the Exetel app</h1>
                    <p className='m-0 mb-2 mb-lg-4 lh'>
                        Say g’day to The One Plan. Simple, fuss-free internet, packed with all the stuff you love. Things like 100Mbps speeds, the ability to pause your internet, and the option to temporarily blast your speed with Warp Speed. Plus, you can Refer a Friend and get $1 off your monthly bill. Sound pretty good, huh? 
                    </p>
                    {props.serviceAddress && <p>Eligible nbn service: {props.serviceAddress}</p>}
                    <p className="mt-4">Download the app and make the switch to The One Plan today.</p>
                    <div>
                    <img src='/images/QR.png' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MoveToOnePlanBanner


// WEBPACK FOOTER //
// ./resources/js/modules/MoveToOnePlan/MoveToOnePlanBanner.js